<script setup>
import { computed } from 'vue';
// BonBoZ: bảy chữ đầu hàng trước đây viết cứng ['M','T','W','T','F','S','S'].
// `computed` chứ không phải hằng số ở cấp module: đổi ngôn ngữ trong lúc đang
// dùng thì lịch phải đổi theo, mà hằng số thì đã tính xong từ lúc import.
// Lịch này bắt đầu từ THỨ HAI (bản gốc mở đầu bằng 'M'), nên truyền `false`.
import { dauThu } from 'dashboard/helper/dinhDangNgay';

const cacThu = computed(() =>
  dauThu(false).map((label, i) => ({ id: i + 1, label }))
);
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in cacThu"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
